(function () {
    'use strict';
    var m = angular.module('settings');
    m.controller('SystemConfigController', ["$scope", function ($scope) {
        $scope.passwordSecurityPanel = {
            title: 'Password Security Policy',
            'class': 'light white-body white-header no-margin',
            bodyStyle: { 'min-height': '175px' }
        };
    }]);
}());